import { InjectionToken } from '@angular/core';
import { NovaPortalLibConfig } from './nova-portal-lib-config.interface';

export const LIB_CONFIG = new InjectionToken<NovaPortalLibConfig>('NovaPortalLibConfig');
